import React, { useState } from "react";
import LeaveApprovalsListController from "../Controllers/LeaveApprovalsListController";
import Loader from "../../Components/Loader";
import downArrow from "../../Assets/Icons/chevron-down.png";
import { convertGMTToLocal, getLeaveWeekdays, getLeaveDates, getLeaveDatesWithDays } from "../../Utils/Validation";
import LeaveApproveRejectModal from "../Components/LeaveApproveRejectModal";

const LeaveApprovalsListScreen = ({ leaveApprovalList, loading, error, onRefresh }) => {
    const {
        currentApprovals, approvalRejectInfoRef,
        isApprovalRejectModalOpen,
        handleApproveRejectClick, handleCloseModal,
        getStatusStyle,
        currentPage, totalPages, visiblePages, handlePageChange,
        OnAddUpdateSuccess,
        showApproved, handleShowApproved,
        daysExpandedRows, daysToggleExpand,
        datesExpandedRows, datesToggleExpand,
        expandedRows, toggleExpand,
        expandedComments, toggleCommentExpansion,
    } = LeaveApprovalsListController(onRefresh, leaveApprovalList);

    return (
        <div className="basic-info-container">
            <div style={{ display: "flex", justifyContent: "space-between", paddingBottom: 10, alignItems: "center" }}>
                {/* <h3 style={styles.categoryHeader}>Approvals</h3> */}
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <h3 style={styles.categoryHeader}>Approvals</h3>
                    {currentApprovals?.length > 0 && currentApprovals[0]?.approval_count > 0 && (
                        <div className="approval-count-badge">
                            {String(currentApprovals[0]?.approval_count).padStart(2, '0')}
                        </div>
                    )}
                </div>
                <div
                    style={styles.showTasktyle}
                    onClick={() => handleShowApproved()} // Toggle showApproved state
                >
                    {showApproved ? "Hide Approved Leaves" : "Show Approved Leaves"}
                </div>
            </div>

            <div style={styles.tableWrapper}>
                <table className="tasksScreen-task-table">
                    <thead>
                        <tr>
                            <th style={{ width: "10%" }}>Employee Name</th>
                            <th style={{ width: "12%" }}>Date</th>
                            <th style={{ width: "12%" }}>Day of the Week</th>
                            <th style={{ width: "15%" }}>Leave Type</th>
                            <th style={{ width: "10%" }}>No. of days</th>
                            <th style={{ width: "15%" }}>Comment</th>
                            <th style={{ width: "15%" }}>Reject Reason</th>
                            <th style={{ width: "10%" }}>Status</th>
                            <th style={{ width: "10%" }}>Action</th>
                        </tr>
                    </thead>

                    {currentApprovals.length > 0 && (
                        <tbody style={{ backgroundColor: "white" }}>
                            {currentApprovals.map((approval, index) => {
                                // const days = getLeaveWeekdays(request?.start_date, request?.end_date);
                                // const isExpanded = daysExpandedRows[index];
                                const leaveDetails = getLeaveDatesWithDays(approval?.start_date, approval?.end_date)
                                // const leaveDetails = getLeaveDatesWithDays(convertGMTToLocal(request?.start_date,'dd/MM/yyyy'), convertGMTToLocal(request?.end_date,'dd/MM/yyyy'));
                                return (
                                    < tr key={index} >
                                        <td style={styles.tableValue}>{approval?.leave_req_emp_name || '--'}</td>
                                        {/* <td style={styles.tableValue}>{approval?.start_date ? convertGMTToLocal(approval?.start_date, 'dd/MM/yyyy') : '--'}</td> */}
                                        {/* <td style={styles.tableValue}>{approval?.day_of_week}</td> */}
                                        <td style={styles.tableValue}>
                                            {leaveDetails.length <= 2 ? (
                                                leaveDetails.map((d) => d.date).join(", ")
                                            ) : expandedRows[`${index}-dates`] ? (
                                                <>
                                                    {leaveDetails.map((d) => d.date).join(", ")}{" "}
                                                    <span className="show-more-less" onClick={() => toggleExpand(`${index}-dates`)}>
                                                        Show less
                                                    </span>
                                                </>
                                            ) : (
                                                <>
                                                    {leaveDetails.slice(0, 2).map((d) => d.date).join(", ")}{" "}
                                                    <span className="show-more-less" onClick={() => toggleExpand(`${index}-dates`)}>
                                                        +{leaveDetails.length - 2} more
                                                    </span>
                                                </>
                                            )}

                                        </td>
                                        <td style={styles.tableValue}>
                                            {leaveDetails.length <= 2 ? (
                                                leaveDetails.map((d) => d.day).join(", ")
                                            ) : expandedRows[`${index}-days`] ? (
                                                <>
                                                    {leaveDetails.map((d) => d.day).join(", ")}{" "}
                                                    <span className="show-more-less" onClick={() => toggleExpand(`${index}-days`)}>
                                                        Show less
                                                    </span>
                                                </>
                                            ) : (
                                                <>
                                                    {leaveDetails.slice(0, 2).map((d) => d.day).join(", ")}{" "}
                                                    <span className="show-more-less" onClick={() => toggleExpand(`${index}-days`)}>
                                                        +{leaveDetails.length - 2} more
                                                    </span>
                                                </>
                                            )}
                                        </td>
                                        <td style={styles.tableValue}>{approval?.leave_type_name || '--'}</td>
                                        <td style={styles.tableValue}>{(typeof approval?.total_days === "number" && !isNaN(approval?.total_days)) ? (approval?.total_days < 10 ? `0${approval?.total_days}` : approval?.total_days) : approval?.total_days}</td>
                                        {/* <td style={styles.tableValue}>{approval?.comment ? `${approval?.comment?.slice(0, 10)}...` : '--'}</td> */}
                                        <td style={styles.tableValue}>
                                            {approval?.comment ? (
                                                approval?.comment?.length <= 30 ? ( // Adjust length threshold as needed
                                                    approval?.comment
                                                ) : expandedRows[`${index}-comment`] ? (
                                                    <>
                                                        {approval?.comment}{" "}
                                                        <span
                                                            className="show-more-less"
                                                            onClick={() => toggleExpand(`${index}-comment`)}
                                                            style={{ color: "#5A55D2", cursor: "pointer" }}
                                                        >
                                                            Show less
                                                        </span>
                                                    </>
                                                ) : (
                                                    <>
                                                        {approval?.comment.slice(0, 30)}...{" "}
                                                        <span
                                                            className="show-more-less"
                                                            onClick={() => toggleExpand(`${index}-comment`)}
                                                            style={{ color: "#5A55D2", cursor: "pointer" }}
                                                        >
                                                            More
                                                        </span>
                                                    </>
                                                )
                                            ) : (
                                                "--"
                                            )}
                                        </td>
                                        <td style={styles.tableValue}>
                                            {approval?.reject_reason ? (
                                                approval?.reject_reason?.length <= 30 ? ( // Adjust length threshold as needed
                                                    approval?.reject_reason
                                                ) : expandedRows[`${index}-reject_reason`] ? (
                                                    <>
                                                        {approval?.reject_reason}{" "}
                                                        <span
                                                            className="show-more-less"
                                                            onClick={() => toggleExpand(`${index}-reject_reason`)}
                                                            style={{ color: "#5A55D2", cursor: "pointer" }}
                                                        >
                                                            Show less
                                                        </span>
                                                    </>
                                                ) : (
                                                    <>
                                                        {approval?.reject_reason.slice(0, 30)}...{" "}
                                                        <span
                                                            className="show-more-less"
                                                            onClick={() => toggleExpand(`${index}-reject_reason`)}
                                                            style={{ color: "#5A55D2", cursor: "pointer" }}
                                                        >
                                                            More
                                                        </span>
                                                    </>
                                                )
                                            ) : (
                                                "--"
                                            )}
                                        </td>
                                        {/* <td style={styles.tableValue}>{approval?.reject_reason || '--'}</td> */}
                                        <td style={styles.tableValue}>
                                            <div
                                                style={{
                                                    display: "inline-block",
                                                    padding: "5px 10px",
                                                    borderRadius: "15px",
                                                    ...getStatusStyle(approval?.leave_status_name),
                                                }}
                                            >
                                                {approval?.leave_status_name || '--'}
                                            </div>
                                        </td>
                                        <td style={styles.tableValue}>
                                            {approval?.leave_status === 1 ? (
                                                <span style={styles.tableLink} onClick={() => handleApproveRejectClick(approval)}>
                                                    Approve/Reject
                                                </span>
                                            ) : (
                                                '--'
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    )}
                </table>

                {loading && <Loader loading={loading} color={"var(--primary-loader-color)"} />}
                {error && <div className="list-error-msg">{error}</div>}

                {isApprovalRejectModalOpen &&
                    <LeaveApproveRejectModal isOpen={isApprovalRejectModalOpen} onClose={handleCloseModal} editData={approvalRejectInfoRef.current} onValueChange={OnAddUpdateSuccess} />}

                <div className="tasksScreen-table-footer">
                    <span className="tasksScreen-pagination-info">
                        {`${currentPage}-${totalPages} of items`}
                    </span>
                    <div className="tasksScreen-pagination">
                        <button className="tasksScreen-pagination-button" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1 || totalPages === 0}>
                            <img src={downArrow} alt="Previous" className="tasksScreen-arrow-left tasksScreen-icon-image" />
                        </button>

                        {visiblePages.map((page) => (
                            <button key={page} className={`tasksScreen-pagination-button ${currentPage === page ? "active" : ""}`} onClick={() => handlePageChange(page)}>
                                {page}
                            </button>
                        ))}

                        <button className="tasksScreen-pagination-button" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages || totalPages === 0}>
                            <img src={downArrow} alt="Next" className="tasksScreen-arrow-right tasksScreen-icon-image" />
                        </button>
                    </div>
                </div>
            </div>
        </div >
    );
};

const styles = {
    categoryHeader: {
        color: "#1F384C",
        fontSize: 28,
        fontFamily: "Roboto Slab",
        fontWeight: 500,
    },
    tableWrapper: {
        overflowX: "auto",
        whiteSpace: "nowrap",
        marginBottom: 50,
    },
    tableValue: {
        color: "#192A3E",
        fontFamily: "Roboto",
        fontWeight: 400,
        fontSize: "12px",
    },
    tableLink: {
        fontFamily: "Roboto",
        fontWeight: 400,
        fontSize: "12px",
        textDecoration: "underline",
        color: "#5A55D2",
        cursor: "pointer",
    },
    showTasktyle: {
        color: '#5A55D2',
        fontSize: '12px',
        fontWeight: '400',
        textDecoration: 'underline',
        wordWrap: 'break-word',
        cursor: 'pointer'
    }
};

export default LeaveApprovalsListScreen;
